import { Flex } from '@chakra-ui/react'

import { COLLAPSED_HOME_SIDEBAR_WIDTH_PX } from '@/common/constants/sidebar'

type Props = {
	children: React.ReactNode
}

export const HomeContentLayout = ({ children }: Props) => {
	return (
		<Flex
			as="main"
			w="full"
			paddingLeft={COLLAPSED_HOME_SIDEBAR_WIDTH_PX}
			transition="max-width 250ms ease-in-out, padding-left 250ms ease-in-out"
		>
			{children}
		</Flex>
	)
}
